import ImageComparison from './ImageComparison'

export default ImageComparison
